/** Category ids aligned with record-service CategoryEnum */
export enum EvolutionCategoryId {
    MEDICA = 21,
    ADMIN = 22,
    ANALISIS_IA = 97,
}

export type AiStatus = 'PENDING' | 'PROCESSING' | 'ANALYZED' | 'FAILED' | string;
